/** @format */

import parse from "html-react-parser";

export default function Text(props) {
  return <>{parse(props.text)}</>;
}
